<template>
  <div class="success">
    <img src="../assets/img/bm_icon_4.png" alt="" class="banner">
    <div class="contents">
      <div class="list">
        <div class="btn" :class="{'color1': colorType}" @click="showRule(0)">重要说明</div>
      </div>
      <div class="list">
        <div class="btn" :class="{'color1': colorType}" @click="showRule(1)">如何获得参赛资格证?</div>
      </div>
      <div class="list">
        <div class="btn down" :class="{'gray': type != 1}" @click="download()">资格证下载</div>
        <div class="text">(热度值达到100即可下载)</div>
      </div>
      <div class="list">
        <div class="btn" :class="{'color1': colorType}" @click="share()">点击分享链接获取星热度值</div>
      </div>
    </div>
    <div class="qrcodes">
      <img src="../assets/img/qrcode.png" alt="" class="qrcode">
      <div class="smart">（扫一扫关注微信公众号）</div>
    </div>
    <van-popup v-model="ruleModal" position="center">
      <div class="rule_modal">
        <img src="../assets/img/icon_close.png" alt="" class="icon" @click="ruleModal = false">
        <div class="content" v-html="rule">
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
export default {
  data () {
    return {
      type: '',
      ruleModal: false,
      rule: '',
      rule1: '<p>恭喜你资料已递交！</p><p>温馨提示：所有报名成功的学员需成功下载“新歌来啦·参赛资格证”并于手机保存，才正式获得官方参赛资格，否则参加的任何赛事及个人成绩，均视无效赛事或无效成绩！</p>',
      rule2: '<p>如何获得“新歌来啦·参赛资格证”？</p><p>参赛资格证的获得或成功下载其实很简单，是否能成功下载参赛资格证，是从选手报名成功那一刻的”星热度值”来计算的，当一个选手的“星热度值”大于100时，即可在新歌来啦官方通道用“姓名+身份证号码”登录下载参赛资格证了，然后等待官方授权的赛区运营机构通知本人在当地就近参加正式比赛了。</p><p>如何获得大于100的星热度值？</p><p>1、学员报名成功时，初始即获得10个点的“星热度值”；</p><p>2、学员通过相关的分享方式（如朋友圈、微信群）每获得一个朋友的免费助力支持（点赞）即获得5个点的“星热度值”；</p><p>3、因为学员的分享，如有任何一个音乐爱好者通过该链接进行了报名，即获得50个点的“星热度值”；</p>',
      colorType: false
    }
  },
  mounted () {
    this.type = this.$route.query.iscert;
    this.colorToggle();
    this.getShareConfig();
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
  methods: {
    colorToggle () {
      this.timer = setInterval(() => {
        this.colorType = !this.colorType;
      }, 500);
    },
    getShareConfig () {
      let link = this.isIos ? this.ios_first_url : location.href.split("#")[0];
      let that = this;
      this.axios.post('/Home/WeAuth/getConfig', {
        url: link
      })
        .then(({data}) => {
          if (data.code === 1) {
            wx.config({
              // debug: true,
              appId: data.data.appId,
              timestamp: data.data.timestamp,
              nonceStr: data.data.nonceStr,
              signature: data.data.signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
            });
            wx.ready(function() {
              wx.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                  let options = {
                    title: '新歌来啦官方通道', // 分享标题
                    desc: '为优秀的歌手提供卫星电视的播出平台，欢迎您的参与！', // 分享描述
                    link: location.origin + '/#/', // 分享链接
                    imgUrl: location.origin + '/logo.png', // 分享图标
                    success: function () {
                    // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                    // 用户取消分享后执行的回调函数
                    }
                  }
                  wx.onMenuShareTimeline(options);
                  wx.onMenuShareAppMessage(options);
                  wx.onMenuShareQQ(options);
                  wx.onMenuShareWeibo(options);
                  wx.onMenuShareQZone(options);
                }
              });
            });
          }
        });
    },
    download () {
      if (this.type != 1) {
        this.Toast('热度值达到100即可下载');
      } else {
        this.$router.push('/prove?shareId=' + localStorage.getItem('shareId'));
      }
    },
    showRule (type) {
      this.ruleModal = true;
      if (type == 1) {
        this.rule = this.rule2;
      } else {
        this.rule = this.rule1;
      }
    },
    share () {
      this.$router.push('/share?shareId=' + localStorage.getItem('shareId'));
    }
  }
}
</script>

<style lang="scss" scoped>
  .success{
    background: url('../assets/img/bg.png') no-repeat 0 0 / 100% 2000px;
    padding-bottom:100px;
    .contents{
      padding:90px;
      .list{
        display:flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom:40px;
        .btn{
          width:100%;
          height:80px;
          text-align: center;
          line-height:70px;
          font-style: italic;
          font-size:30px;
          font-weight: bold;
          color:#fff;
          border:5px solid #d0d7f0;
          border-radius: 10px;
          background:linear-gradient(90deg, #138571, #0373a5);
          // animation: backColor 1.5s linear infinite;
          &.color1{
            background:linear-gradient(90deg, #216a89, #153792);
          }
          &.down{
            width:200px;
            &.gray{
              background: #8990a6 !important;
              color:#474747;
            }
          }
          // @keyframes backColor {
          //   0% {
          //     background:linear-gradient(90deg, #138571, #0373a5);
          //   }
          //   100% {
          //     background:linear-gradient(90deg, #138538, #038f79);
          //   }
          // }
        }
        .text{
          font-style: italic;
          font-size:30px;
          font-weight: bold;
          color:#fff;
        }
      }
    }
    .qrcodes{
      text-align: center;
      .qrcode{
        width:300px;
        height:300px;
        pointer-events: auto;
        border-radius: 16px;
      }
      .smart{
        font-size:24px;
        color:#fff;
        letter-spacing: 5px;
        margin-top:20px;
      }
    }
    .rule_modal{
      width:600px;
      background:#fff;
      padding: 50px 40px;
      border-radius: 20px;
      .icon{
        width:40px;
        height:40px;
        position:absolute;
        top:20px;
        right:20px;
        z-index:1;
        pointer-events: auto;
      }
      .title{
        font-size:32px;
        font-weight: bold;
        text-align: center;
      }
      .content{
        margin: 40px 0;
        max-height:800px;
        overflow-y: auto;
        font-size:30px;
        line-height:48px;
        text-indent: 2em;
        text-align: justify;
      }
      .btns{
        display:flex;
        align-items: center;
        justify-content: space-around;
        padding:0 30px;
        .btn{
          width:160px;
          height:70px;
          background:#fff;
          text-align: center;
          line-height:70px;
          font-size:36px;
          border-radius: 12px;
          border:2px solid #000;
        }
      }
    }
  }
</style>